import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'


interface Options {
  shiftId: string,
  serialId: number,
}
export const apiShiftGetOne = ({
  shiftId,
  serialId,
}: Options) => {
  const data = {
  }
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/v2/shifts/${shiftId}`,
    data,
    params: {
      reqSid: serialId,
    }
  }
  return ax(options)
}